<div *ngIf="message" class="application-environment-message">
  {{ message.toUpperCase() }}
</div>
